import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { TableCell, TableRow } from '@/components/ui/table';
import { fgText, fmtQty, prApi } from '@/services/prApi';

/** Expanded requisition row: each line's FG, design, required / on POs / still to order. */
export const PrItemsRow = ({ prId, colSpan, fgName }) => {
  const [items, setItems] = useState(null);
  useEffect(() => { prApi.get(prId).then((p) => setItems(p.items || [])).catch(() => setItems([])); }, [prId]);
  return (
    <TableRow className="bg-indigo-50/40 hover:bg-indigo-50/40" data-testid={`pr-items-row-${prId}`}>
      <TableCell colSpan={colSpan} className="px-6 py-2">
        {!items ? <Loader2 className="h-4 w-4 animate-spin text-indigo-600" /> : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[11px] uppercase tracking-wide text-gray-500">
              <th className="py-1 pr-3">FG Name</th><th className="py-1 pr-3">Design · Shade · Size · Description</th>
              <th className="py-1 text-right">Qty</th><th className="py-1 text-right">On POs</th><th className="py-1 text-right">Still to order</th></tr></thead>
            <tbody>{items.map((it) => (
              <tr key={it.pr_item_id} className={`border-t border-indigo-100 ${fgName && it.mapped_fg_name === fgName ? 'bg-amber-50' : ''}`} data-testid={`pr-items-line-${it.pr_item_id}`}>
                <td className="py-1 pr-3 font-mono font-semibold">{it.mapped_fg_name || <span className="font-sans italic text-gray-400">no FG</span>}</td>
                <td className="py-1 pr-3 text-gray-700">{fgText(it) || it.design_name}</td>
                <td className="py-1 text-right tabular-nums">{fmtQty(it.required_qty)} {it.unit}</td>
                <td className="py-1 text-right tabular-nums text-indigo-700">{fmtQty(it.ordered_qty)}</td>
                <td className={`py-1 text-right tabular-nums ${it.balance_qty > 0 ? 'font-semibold text-amber-700' : ''}`}>{fmtQty(it.balance_qty)}</td>
              </tr>))}
            {!items.length && <tr><td colSpan={5} className="py-2 text-xs text-gray-500">No lines on this requisition</td></tr>}</tbody>
          </table>)}
      </TableCell>
    </TableRow>
  );
};

export default PrItemsRow;
